<template>
  <VCard
    class="countdown-box pa-md-3 pa-2 d-inline-flex flex-column border align-center"
    style="width: fit-content"
    elevation="0"
  >
    <div
      class="d-flex justify-space-between mx-1 font-weight-bold font-size-xs font-size-md-l w-100 mb-1"
    >
      <span>{{ translate('countdown_mins_plural') }}</span>
      <span>{{ translate('countdown_secs_plural') }}</span>
    </div>
    <div
      class="d-flex align-center justify-center font-size-md-xxxxl font-size-m font-weight-bold"
    >
      <span class="digits">{{ minutesLeft }}</span>
      <span class="mx-2">:</span>
      <span class="digits">{{ secondsLeft }}</span>
    </div>
  </VCard>
</template>

<script setup>
import { computed, onMounted, onUnmounted, ref } from 'vue'
import { VCard } from 'vuetify/components'

const props = defineProps({
  minutes: {
    type: Number,
    default: 15
  },
  targetTimestamp: {
    type: Number,
    default: null
  }
})

const emit = defineEmits(['expired'])

const minutesLeft = ref('00')
const secondsLeft = ref('00')
let interval

const targetTime = computed(() => {
  if (props.targetTimestamp) {
    return props.targetTimestamp
  }
  return Date.now() + props.minutes * 60 * 1000
})

const updateCountdown = () => {
  const now = Date.now()
  const difference = targetTime.value - now

  if (difference <= 0) {
    clearInterval(interval)
    minutesLeft.value = '00'
    secondsLeft.value = '00'
    emit('expired')
    return
  }

  const mins = Math.floor(difference / (1000 * 60))
  const secs = Math.floor((difference % (1000 * 60)) / 1000)

  minutesLeft.value = String(mins).padStart(2, '0')
  secondsLeft.value = String(secs).padStart(2, '0')
}

onMounted(() => {
  updateCountdown()
  interval = setInterval(updateCountdown, 1000)
})

onUnmounted(() => {
  clearInterval(interval)
})
</script>

<style scoped>
.digits {
  min-width: 2ch;
  text-align: center;
}
</style>
